import todolistImg from './images/todo-list.png';
import englishTestsImg from './images/english-tests.png';
import menuappImg from './images/menu-app.png';
import socketIoIcon from './images/Socketio.svg';
import reactIcon from './images/react.svg';
import tailwindcssIcon from './images/tailwind.png';
import javascriptIcon from './images/js.svg';
import cssIcon from './images/css3.svg';
import firebaseIcon from './images/firebase.png';
import nextIcon from './images/nextjs.png';
import turkiyeyiGeziyorumImg from './images/turkiyeyi-geziyorum.png'; 
import goruselimImg from './images/goruselim.png'; 
import goruselimVideo from './videos/goruselim-video.mp4'; 
import englishTestVideo from './videos/english-tests-video.mp4';
import menuAppVideo from './videos/menu-app-video.mp4';
import todoListVideo from './videos/todo-list-video.mp4';

import TurkiyeyiGeziyorumVideo from './videos/turkiyeyigeziyorum-video.mp4';
export const Projects =[
     {
    id:1,
    title:"Görüşelim",
    description:"project-goruselim-desc",
    img:goruselimImg,
    video:goruselimVideo,
    developedWith:[
        {
        img:reactIcon,
        value:"React",
        },
        {
        img:tailwindcssIcon,
        value:"Tailwind",
        },
        {
        img:javascriptIcon,
        value:"Javascript",
        },
        {
        img:firebaseIcon,
        value:"Firebase",
        },
        {
        img:socketIoIcon,
        value:"Socket.io",
        },
    ],
    github:"https://github.com/Eren-Koc/goruselim-frontend",
    linkedin:"https://www.linkedin.com/feed/update/urn:li:activity:7454615721042468865/",
    website:"https://goruselim.com",
    },
    {
    id:2,
    title:"English Tests",
    description:"project-englishtests-desc",
    img:englishTestsImg,
    video:englishTestVideo,
    developedWith:[
        {
        img:reactIcon,
        value:"React",
        },
        {
        img:tailwindcssIcon,
        value:"Tailwind",
        },
        {
        img:javascriptIcon,
        value:"Javascript",
        },
        {
        img:cssIcon,
        value:"Css",
        },
        {
        img:firebaseIcon,
        value:"Firebase",
        },
    ],
    github:"https://github.com/Eren-Koc/english-tests",
    linkedin:"https://www.linkedin.com/feed/update/urn:li:activity:7158913129811263488/",
    website:"https://english-tests-erenkoc.vercel.app/",
    },
    {
        id:3,
        title:"Türkiyeyi Geziyorum",
        description:'project-travel-desc',
        img:turkiyeyiGeziyorumImg,
        video:TurkiyeyiGeziyorumVideo,
        developedWith:[
            {
                img:reactIcon,
                value:"React",
            },
            {
            img:tailwindcssIcon,
            value:"Tailwind",
            },
            {
            img:javascriptIcon,
            value:"Javascript",
            },
            {
            img:cssIcon,
            value:"Css",
            },
            {
        img:firebaseIcon,
        value:"Firebase",
        },
        ],
        github:"https://github.com/Eren-Koc/turkiyeyi-geziyorum",
        linkedin:"https://www.linkedin.com/feed/update/urn:li:ugcPost:7286865613803720704/",
        website:"https://turkiyeyi-geziyorum.vercel.app/",
        },

        {
            id:4,
            title:"Menu App",
            description:"project-menuapp-desc",
            img:menuappImg,
            video:menuAppVideo,
            developedWith:[
              
                {
                    img:nextIcon,
                    value:"Next",
                },
                {
                img:tailwindcssIcon,
                value:"Tailwind",
                },
                {
                img:javascriptIcon,
                value:"Javascript",
                },
                {
                img:cssIcon,
                value:"Css",
                },
                {
            img:firebaseIcon,
            value:"Firebase",
            },
            ],
            github:"https://github.com/Eren-Koc/menu-app",
            linkedin:"https://www.linkedin.com/feed/update/urn:li:activity:7246536261304213505/",
            website:"https://menu-app-erenkocs-projects.vercel.app/",
            },

    {
        id:5,
        title:"To-do List",
        description:"project-todo-desc",
        img:todolistImg,
        video:todoListVideo,
        developedWith:[
            {
            img:reactIcon,
            value:"React",
            },
            {
            img:tailwindcssIcon,
            value:"Tailwind",
            },
            {
            img:javascriptIcon,
            value:"Javascript",
            },
            {
            img:cssIcon,
            value:"Css",
            },
            {
        img:firebaseIcon,
        value:"Firebase",
        },
        ],
        github:"https://github.com/Eren-Koc/todo-list",
        linkedin:"https://www.linkedin.com/in/eren-ko%C3%A7/details/projects/",
        website:"https://todo-list-erenkoc.vercel.app/",
        },


            

    
]